let syncChartTheme: (() => void) | undefined

export const registerChartThemeSync = (sync: () => void) => {
  syncChartTheme = sync
  syncChartTheme()
}

export const syncRegisteredChartTheme = () => syncChartTheme?.()
